<template>
  <div class="customer-management">
    <div>
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-col :span="20">
          <el-form-item label="年份">
            <el-select v-model="searchForm.year" placeholder="请选择年份" size="mini" class="w130" @change="handleSearch">
              <el-option
                v-for="year in yearOptions"
                :key="year"
                :label="year + '年'"
                :value="year"
              ></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="店铺">
            <el-select v-model="searchForm.store" filterable placeholder="请输入" class="w150" size="small"  @change="handleSearch">
              <el-option v-for="item in shopOptionsList" :key="item.shopId" :label="item.shopName" 
                :value="item.shopId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4" style="text-align: right;">   
          <el-form-item>
            <el-button type="primary" @click="handleSearch" size="mini">搜索</el-button>
            <el-button @click="handleSearch('export')" :loading="btnLoading" type="primary" size="mini">导出数据</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <h2 class="title">{{shop_name}}保有客户动态管理表</h2>

    <el-table
      :data="tableData"
      border
      stripe
      :span-method="objectSpanMethod"
      style="width: 100%"
      max-height="600"
      :cell-style="cellStyle"
      v-loading="loading"
    >
      <!-- 护理师列：对应后端nurse_name -->
      <el-table-column
        prop="nurseName"
        label="护理师"
        width="80"
        align="center"
        fixed="left"
      ></el-table-column>
      <!-- 客户姓名列：对应后端customer_name -->
      <el-table-column
        prop="customerName"
        label="客户姓名"
        width="100"
        align="center"
        fixed="left"
      ></el-table-column>
      <el-table-column
        prop="telephone"
        label="手机号"
        width="110"
        align="center"
        fixed="left"
      ></el-table-column>

      <!-- 根据后端monthConfig动态生成月份列 -->
      <template v-for="month in monthColumns">
        <el-table-column
          :key="month.value"
          :label="month.label"
          align="center"
        >
          <!-- 到店频次：对应everyday_enter_num -->
          <el-table-column
            :prop="`${month.value}.everydayEnterNum`"
            label="到店频次"
            :width="80"
            align="center"
          ></el-table-column>
          <!-- 护理量：对应nurse_count -->
          <el-table-column
            :prop="`${month.value}.nurseCount`"
            label="护理量"
            :width="80"
            align="center"
          ></el-table-column>
          <!-- 消费额：对应consume_balance -->
          <el-table-column
            :prop="`${month.value}.outboundBalance`"
            label="销售额"
            :width="100"
            align="center"
          ></el-table-column>
          <!-- 消耗额：对应outbound_balance -->
          <el-table-column
            :prop="`${month.value}.consumeBalance`"
            label="消耗额"
            :width="100"
            align="center"
          ></el-table-column>
        </el-table-column>
      </template>
    </el-table>

    <!-- 分页控件 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
      style="margin-top: 10px; text-align: right;"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getShopList } from "@/api/shop";
import { dynamicRetainCustomer } from "@/api/statistics";
export default {
  name: 'CustomerDynamicManagement',
  data() {
    return {
      btnLoading: false,
      loading: false,
      shop_name: '',
      tableData: [],
      monthColumns: [], 
      spanConfig: {
        nurseName: [] // 改为nurseName对应护理师
      },
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      searchForm: {
        year: new Date().getFullYear(),
        store: '' 
      },
      shopOptionsList: [],
      yearOptions: [],
    }
  },
  created() {
    this.getOptions()
    this.generateYearOptions()
  },
  methods: {
     async exportData() {
      this.btnLoading = true
      try {
        const res = await dynamicRetainCustomer({
          page: this.pagination.page,
          limit: this.pagination.limit,
          year: this.searchForm.year,
          shop_id:  this.searchForm.store,
          export: 1
        })
        window.open(res.data)
        this.btnLoading = false
      } catch (error) {
        this.btnLoading = false
        this.$message.error(error.message || '导出失败');
      } finally {
        this.btnLoading = false
      }
    },
  cellStyle({columnIndex}){
    if(columnIndex <= 2){
        return 'background:#D9E1F4;text-align:center'
    }
    if((columnIndex >= 3 && columnIndex <= 6) || (columnIndex >= 15 && columnIndex <= 18) || (columnIndex >= 27 && columnIndex <= 30) || (columnIndex >= 39 && columnIndex <= 42)){
        return 'background:#FDE9D9;text-align:center'
    }
    if((columnIndex >= 7 && columnIndex <= 10) || (columnIndex >= 19 && columnIndex <= 22) || (columnIndex >= 31 && columnIndex <= 34) || (columnIndex >= 43 && columnIndex <= 46)){
        return 'background:#D8E4BC;text-align:center'
    }
    if((columnIndex >= 11 && columnIndex <= 14) || (columnIndex >= 23 && columnIndex <= 26) || (columnIndex >= 35 && columnIndex <= 38) || (columnIndex >= 47 && columnIndex <= 50)){
        return 'background:#FADADE;text-align:center'
    }
    return '';
  },
    getOptions() {
      this.loading = true
      getShopList({ page: 1, limit: 100000}).then(res => {
        this.shopOptionsList = res.list || [];
        this.searchForm.store = this.shopOptionsList.length > 0 ? this.shopOptionsList[0].shopId : ''
         this.fetchTableData()
      });
    },
    generateYearOptions() {
      const currentYear = new Date().getFullYear();
      const startYear = 2025; // 从2025年到当前年
      this.yearOptions = [];
      // 修正年份生成逻辑：从startYear到currentYear倒序
      for (let i = currentYear; i >= startYear; i--) {
        this.yearOptions.push(i);
      }
    },

    handleSearch(type) {
      if(type === 'export'){
        this.exportData()
      }else{
        this.pagination.page = 1
        this.fetchTableData()
      }
    },

    resetSearch() {
      this.searchForm = {
        year: new Date().getFullYear(),
        store: ''
      }
      this.pagination.page = 1
      this.fetchTableData()
    },

    async fetchTableData() {
      this.loading = true
      try {
        const res = await dynamicRetainCustomer({
          page: this.pagination.page,
          limit: this.pagination.limit,
          year: this.searchForm.year,
          shop_id:  this.searchForm.store 
        })
        const { monthConfig, tableData, shop_name } = res.data || {};
        this.shop_name = shop_name || '';
        this.monthColumns = monthConfig || [];
        this.tableData = this.formatTableData(tableData.list || []);
        this.pagination.total = tableData.total || 0;
        this.calcSpanConfig();
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },

    formatTableData(data) {
      return data.map(item => {
        const formattedItem = {
          shopId: item.shop_id || '',
          nurseName: item.nurse_name || '',
          customerName: item.customer_name || '',
          telephone: item.telephone || '',
        };
        this.monthColumns.forEach(month => {
          const monthData = item[month.value] || {};
          formattedItem[month.value] = {
            everydayEnterNum: monthData.everyday_enter_num || 0, 
            nurseCount: monthData.nurse_count || 0, 
            consumeBalance: monthData.consume_balance || 0, 
            outboundBalance: monthData.outbound_balance || 0, 
          };
        });
        return formattedItem;
      });
    },

    calcSpanConfig() {
      const { tableData } = this;
      this.spanConfig = { nurseName: [] };
      if (tableData.length === 0) return;

      let nurseSpan = 1;
      for (let i = 0; i < tableData.length; i++) {
        if (i < tableData.length - 1 && 
            tableData[i].nurseName === tableData[i + 1].nurseName && 
            tableData[i].shopId === tableData[i + 1].shopId) {
          nurseSpan++;
        } else {
          this.spanConfig.nurseName.push({
            row: i - nurseSpan + 1,
            rowspan: nurseSpan,
            colspan: 1
          });
          for (let j = 1; j < nurseSpan; j++) {
            this.spanConfig.nurseName.push({ 
              row: i - nurseSpan + 1 + j, 
              rowspan: 0, 
              colspan: 0 
            });
          }
          nurseSpan = 1;
        }
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const config = this.spanConfig.nurseName.find(item => item.row === rowIndex);
        return config ? { rowspan: config.rowspan, colspan: config.colspan } : { rowspan: 1, colspan: 1 };
      }
      return { rowspan: 1, colspan: 1 };
    },

    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1;
      this.fetchTableData();
    },

    handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchTableData();
    }
  },
}
</script>

<style scoped>
.customer-management {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}
.title {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}
.search-section {
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
}
.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
</style>